import { Route } from 'react-router-dom';
import DeliveryBoardPage from './pages/DeliveryBoardPage';
import DeliveryCutPage from './pages/DeliveryCutPage';
import DeliveryConfigPage from './pages/DeliveryConfigPage';
import CourierPage from './pages/CourierPage';

// Módulo cross `delivery` (repartos a domicilio, 23-oct-2026). El gating por módulo lo hacen PATH_MODULE
// (las tres rutas → 'delivery') + el menú; la configuración exige además `manage` en la página/servidor.
export const DeliveryRoutes = [
  <Route key="delivery" path="/dashboard/repartos" element={<DeliveryBoardPage />} />,
  <Route key="delivery-cut" path="/dashboard/repartos/corte" element={<DeliveryCutPage />} />,
  <Route key="delivery-config" path="/dashboard/repartos/configuracion" element={<DeliveryConfigPage />} />,
];

// Página del repartidor: pública (fuera de PrivateRoute), el token del enlace es su llave.
export const CourierRoutes = [
  <Route key="courier" path="/repartidor/:token" element={<CourierPage />} />,
];
